// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// kendo-ui modules
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DropDownsModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

// 3rd party modules
//import { ChartsModule } from 'ng2-charts/ng2-charts';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DialogModule } from '@progress/kendo-angular-dialog';
import 'hammerjs';

// TrazeLab routing module
import { DashboardRoutingModule } from './dashboard-routing.module';
import { TranslatorLazyModule } from '@app/shared/translate/translator-lazy.module';

// TrazeLab components
import { DashboardComponent } from './dashboard.component';
import { SessionGraphFormComponent } from '@app/views/dashboard/session-graph-form/session-graph-form.component';
import {LineChartReactiveComponent} from '../../shared/component/charts/line-chart-reactive/line-chart-reactive.component';


@NgModule({
  imports: [
    LayoutModule,
    DropDownsModule,
    MultiSelectModule,
    ButtonsModule,
    GridModule,
    ExcelModule,
    PDFModule,
    InputsModule,
    DateInputsModule,
    TooltipModule,
    TranslatorLazyModule,
    CommonModule,
    FormsModule,
    DashboardRoutingModule,
    //ChartsModule,
    BsDropdownModule,
    FullCalendarModule,
    ChartsModule,
    DialogModule,
    SlickCarouselModule,
    
  ],
  declarations: [
    DashboardComponent,
    SessionGraphFormComponent,
    LineChartReactiveComponent,
    
  ],
  entryComponents: [
    SessionGraphFormComponent,
    LineChartReactiveComponent,
    
  ]
})
export class DashboardModule { }
